import { useState } from 'react';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import { useTheme } from '@material-ui/core';
import { history } from 'umi';
import AddIcon from '@material-ui/icons/Add';
import { OPT_ADD } from '@/constants';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import { OPT_EDIT, OPT_DETAIL } from '@/constants';
import ResultListStyled from './ResultListStyled';
const ResultList = (props) => {
  const theme = useTheme();
  const {
    handlePageChange,
    pageData,
    listLoading,
    handleClickDelete,
    openDialog,
    setOpenDialog,
    handleClickRow,
  } = props;
  //列表数据
  const { data, total } = props?.tableData || {};
  const [currentAction, setCurrentAction] = useState({});

  const columns = [
    {
      align: 'center',
      title: '部门编号',
      id: 'id',
      key: 'id',
      width: 180,
    },
    {
      align: 'center',
      title: '部门名称',
      id: 'depName',
      key: 'depName',
      width: 180,
    },
    {
      align: 'center',
      title: '部门人数',
      id: 'count',
      key: 'count',
      width: 220,
    },
    {
      align: 'center',
      title: '更新时间',
      id: 'updateDate',
      key: 'updateDate',
      width: 170,
    },

    {
      title: '操作',
      align: 'center',
      // id: 'mobile',
      // key: 'mobile',
      width: 140,
      render: (rowInfo) => {
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title="编辑">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  handleClickRow({
                    pathname:
                      '/coupon/redemption_voucher_verification_department/edit',
                    query: {
                      opt: OPT_EDIT,
                      id: String(rowInfo.id),
                      depName: rowInfo.depName,
                    },
                  });
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={theme.palette.primary.main}
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="详情">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  handleClickRow({
                    pathname:
                      '/coupon/redemption_voucher_verification_department/detail',
                    query: {
                      opt: OPT_DETAIL,
                      id: String(rowInfo.id),
                      depName: rowInfo.depName,
                    },
                  });
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="删除">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                // 删除
                onClick={() => {
                  setOpenDialog(true);
                  if (rowInfo.count > 0) {
                    setCurrentAction({
                      dialogTitle: '删除',
                      dialogContent: '抱歉，需将部门员工移除再删除部门',
                      confirm: () => handleDelete(rowInfo),
                    });
                  } else {
                    setCurrentAction({
                      dialogTitle: '删除',
                      dialogContent: '确定要删除该部门吗？',
                      confirm: () => handleDelete(rowInfo),
                    });
                  }
                }}
              >
                <SvgIconML
                  name="circleDelete"
                  size={22}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  const handleDelete = (rowInfo) => {
    handleClickDelete(rowInfo);
  };

  const handleAddIssuance = () => {
    history.push({
      pathname: '/coupon/redemption_voucher_verification_department/add',
      query: {
        opt: OPT_ADD,
      },
    });
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <ResultListStyled>
      <div className="export-wrapper">
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleAddIssuance}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建部门
        </Fab>
      </div>
      <DataTableNativeML
        loading={listLoading}
        columns={columns}
        changePage={handlePageChange}
        page={pageData}
        // page={searchParam}
        paging={true}
        data={data}
        total={total}
        columnKey="id"
      ></DataTableNativeML>
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
    </ResultListStyled>
  );
};
export default ResultList;
